import React, { useState } from 'react';
import { Bell, User, BookOpen } from 'lucide-react';

type UserType = {
  name: string;
  role?: string;
};

interface TopNavProps {
  isCollapsed: boolean;
  user: UserType | null;
}

export const TopNav: React.FC<TopNavProps> = ({ isCollapsed, user }) => {
  const [showLogout, setShowLogout] = useState(false);
  const toggleLogout = () => {
    setShowLogout((prev) => !prev);
  }

  // const handleLogin = () => {
  //   window.location.href = '/api/v1/auth/login';
  // }
  // const handleLogout = () => {
  //   window.location.href = '/api/v1/auth/logout';
  // };

  return (
    <div className="h-16 bg-background border-b border-border flex items-center justify-between px-6">
      {/* Search */}
      {/* Logo Section */}
      {isCollapsed && (
        <div className="flex items-center space-x-2">
          <BookOpen className="h-8 w-8 text-primary" />
          <span className="text-lg font-semibold text-foreground">Antz</span>
        </div>
      )}
      <div className="flex-1 max-w-2xl">
      </div>


      {/* Right side actions */}
      <div className="flex items-center space-x-4">
        {/* Notifications */}
        <button className="relative p-2 text-muted-foreground hover:text-foreground">
          <Bell className="h-6 w-6" />
          <span className="absolute top-1 right-1 block h-2 w-2 rounded-full bg-red-400 ring-2 ring-background" />
        </button>

        {/* User menu */}
        {/*
        <div className="flex items-center">
          {!user ? (
            <button onClick={handleLogin} className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-50">
              <div className="flex-shrink-0">
                <User className="h-6 w-6 text-gray-400" />
              </div>
              <div className="text-sm text-gray-700 text-left">
                <p className="font-medium">Login</p>
              </div>
            </button>
          ) : (
            <div>
              <button onClick={toggleLogout} className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-50">
                <div className="flex-shrink-0">
                  <User className="h-6 w-6 text-gray-400" />
                </div>
                <div className="text-sm text-gray-700 text-left">
                  <p className="font-medium">Hi {user.first_name}</p> {/* Display the user's name here */}
        {/*<p className="text-xs text-gray-500">{user.role || 'User'}</p>
                </div>
              </button>
              {showLogout && (
                <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-lg shadow-md z-10">
                  <button
                    onClick={handleLogout}
                    className="w-full p-2 text-center text-red-500 hover:bg-red-100 rounded-lg"
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
        */}
      </div>
    </div>
  );
};
